import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class PurchaseCorrectionSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }
    
    renderDOTNET() {
        const { storeId, apiToken, orderId, txnNumber } = this.props;

        return (
            <pre className="sampleCode">
{`namespace Moneris
{ 
 using System;
 public class TestCanadaPurchaseCorrection
 { 
  public static void Main(string[] args)
  { 
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string order_id = "${orderId}";
   string txn_number = "${txnNumber}";
   string crypt = "8";
   string dynamic_descriptor = "123456";
   string processing_country_code = "CA";
   bool status_check = false;

   PurchaseCorrection purchasecorrection = new PurchaseCorrection();
   
   purchasecorrection.SetOrderId(order_id);
   purchasecorrection.SetTxnNumber(txn_number);
   purchasecorrection.SetCryptType(crypt);
   purchasecorrection.SetDynamicDescriptor(dynamic_descriptor);
   purchasecorrection.SetCustId("my customer id");

   HttpsPostRequest mpgReq = new HttpsPostRequest();

   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(purchasecorrection);
   mpgReq.SetStatusCheck(status_check);
   mpgReq.Send();

   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("ISO = " + receipt.GetISO());
    Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("Ticket = " + receipt.GetTicket());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("IsVisaDebit = " + receipt.GetIsVisaDebit());
    Console.ReadLine();
   } 
   catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken, orderId, txnNumber } = this.props;

        return (
            <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;
public class TestCanadaPurchaseCorrection
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String order_id = "${orderId}";
  String txn_number = "${txnNumber}";
  String crypt = "7";
  String dynamic_descriptor = "123456";
  String processing_country_code = "CA";
  boolean status_check = false;

  PurchaseCorrection purchasecorrection = new PurchaseCorrection();

  purchasecorrection.setOrderId(order_id);
  purchasecorrection.setTxnNumber(txn_number);
  purchasecorrection.setCryptType(crypt);
  purchasecorrection.setDynamicDescriptor(dynamic_descriptor);
  purchasecorrection.setCustId("my customer id");

  HttpsPostRequest mpgReq = new HttpsPostRequest();

  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setTransaction(purchasecorrection);
  mpgReq.setStatusCheck(status_check);
  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("CardType = " + receipt.getCardType());
   System.out.println("TransAmount = " + receipt.getTransAmount());
   System.out.println("TxnNumber = " + receipt.getTxnNumber());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("TransType = " + receipt.getTransType());
   System.out.println("ReferenceNum = " + receipt.getReferenceNum());
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ISO = " + receipt.getISO());
   System.out.println("BankTotals = " + receipt.getBankTotals());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("AuthCode = " + receipt.getAuthCode());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("Ticket = " + receipt.getTicket());
   System.out.println("TimedOut = " + receipt.getTimedOut());
   System.out.println("IsVisaDebit = " + receipt.getIsVisaDebit());
  } 
  catch(Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken, orderId, txnNumber } = this.props;

        return (
            <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
$orderid='${orderId}';
$txnnumber='${txnNumber}';
$dynamic_descriptor='1234';

## step 1) create transaction hash ###
$txnArray=array('type'=>'purchasecorrection',
'txn_number'=>$txnnumber,
'order_id'=>$orderid,
'crypt_type'=>'7',
'cust_id'=>'customer ID',
'dynamic_descriptor'=>$dynamic_descriptor
);

## step 2) create a transaction object passing the array created in
## step 1.
$mpgTxn = new mpgTransaction($txnArray);

## step 3) create a mpgRequest object passing the transaction object created
## in step 2
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

## step 4) create mpgHttpsPost object which does an https post ##
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

## step 5) get an mpgResponse object ##
$mpgResponse=$mpgHttpPost->getMpgResponse();

## step 6) retrieve data using get methods
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nIsVisaDebit = " . $mpgResponse->getIsVisaDebit());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, orderId, txnNumber, currency, onEditId } = state.transactions.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, orderId, txnNumber, currency, onEditId, progLangId: selection };
  }
  
  export default connect(mapStateToProps, {})(PurchaseCorrectionSample)